import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_2 = { class: "text-[11px] text-Text/text_medium" }
const _hoisted_3 = { class: "font-gordita-medium" }

import { inject, computed } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useCoordinatorInfoQuery } from '@/graphql/codegen/generated/graphql';
import { dateUtils } from '@/services/dateUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'coordinatorUpTime',
  setup(__props) {

const coordinatorsService = inject(IKCoordinatorsService);
const coordinatorInfo = useCoordinatorInfoQuery({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' });
const upTime = computed(() => dateUtils.getRunningSinceDateFormat(Number(coordinatorInfo.result.value?.ibManagerEntities?.coordinatorInfo?.runningSince)));

return (_ctx: any,_cache: any) => {
  return (_unref(coordinatorInfo).result.value?.ibManagerEntities?.coordinatorInfo?.runningSince)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('generic.coordinatorUpTime.runningSince')), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(upTime)), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})